import liteKey from "@/page/ly/liteKey.json"
const getters = {
  caselist: state => state.Case.list,     //案件列表
  APIKEY: state => state.Dictionary.apikey,
  debIndex: (state, getters) => {
    const index = getters.caselist.findIndex(ele => {
      return ele.id == state.cause.id
    })
    return index
  },
  debInfo: state => state.Debinfo.info,         //案件详情
  dislog: state => state.dislog,                      //弹窗              显示组合
  DisForm: state => state.DisForm,                    //弹窗 滑动 参数
  litetit: state => liteKey[state.StepLite || 0],      //弹窗进度标题
  Edit: state => state.Edit,      //弹窗修改 查看 新增
  Stages: state => state.Stages,
  publicPower: state => {   //是否結清 是否是管理員 是否作廢 是否是管理員 是否已延期 的究極判斷  
    const debInfo = state.Debinfo.info
    //return (debInfo.is_clear != 1 || state.user.id <= 1) && (state.cause.invaild != 1 || state.user.id <= 1)
    return (debInfo.is_clear != 1 || state.user.id <= 1)
  },
  stepPower: state => {     //訴訟進度中 因为部分进度公用 故根据当前打开的案件进度框  来设置当前焦点下的案件进度是否可编辑权限 和  可删除权限 查看权限放在列表点击上
    const key = state.StepKey    //当前打开进度的lite 具体lite查看 ly下面的liteKey.json 或者 step.json  lite指当前进度的特定code约定值
    const edit = state.cause.invaild == 0 ? (state.editJA ? 'cause:step:ja:edit' : `${key}:edit`) : `cause:invaildl:step:edit` //优先未作废 然后判断是否已結案
    return {
      edit: edit,      //编辑权限
      del: edit,        //删除权限
      see: `${key}:lists`,  //查看权限
      add: edit         //新增权限
    }
  }
}
export default getters
